import { Component } from '@angular/core';

@Component({
  selector: 'app-emenu',
  templateUrl: './emenu.component.html',
  styleUrls: ['./emenu.component.css']
})
export class EmenuComponent {

}
